<template>
  <div class="historico-estados">
    <h3>Histórico de Estados</h3>
    <v-timeline
        dense
    >
      <v-timeline-item
          :key="estado.id"
          v-for="estado of historico"
      >
        <v-row>
          <v-col cols="auto">{{ estado.fecha | formatDateFull }}</v-col>
          <v-col cols="auto">
            {{ estado.nombreEstado }} - {{estado.nombreUsuario}}
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import dateFiltersMixin from '@/mixins/dateFiltersMixin';
import { mapActions, mapState } from 'vuex';

export default {
name: "HistoricoEstados",
  mixins: [dateFiltersMixin],
  props: {
    idFormulario: {
      type: String|Number,
      required: true,
    },
  },
  methods: {
    ...mapActions('estados', ['getHistorico', ]),
  },
  computed: {
    ...mapState('estados', ['historico', ]),
  },
  watch: {
    idFormulario: {
      immediate: true,
      handler(val) {
        this.getHistorico(this.idFormulario);
      },
    },
  },
}
</script>

<style scoped>

</style>
